import React, { Component } from "react";

import ApiNgos from "../../utils/api.ngos";
import { Modal, ModalBody } from "reactstrap";
import MessageModal from "../../components/Message";

class SubmitModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {},
      title: "Submitted with Success",
      message:
        "Yay, your NGO was submitted to our consulters, soon we will give you a answer!",
      modal: false
    };

    this.handleInput = this.handleInput.bind(this);
    this.handleSumit = this.handleSumit.bind(this);
    this.modalToggle = this.modalToggle.bind(this);
  }

  handleInput(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let form = this.state.form;
    form[name] = value;

    this.setState(...this.state, { form: form });
  }

  modalToggle() {
    this.setState(...this.state, { modal: !this.state.modal });
  }

  handleSumit(e) {
    e.preventDefault();

    ApiNgos.post(this.state.form).then(response => {
      this.modalToggle();
    });
  }

  render() {
    let { isOpen, toggle } = this.props;

    return (
      <div>
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          className="modal-lg custom-modal"
        >
          <ModalBody>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-9">
                  <h1>
                    Submit Your NGO
                    <span className="pointer" onClick={this.props.toggle}>
                      <i className="far fa-times-circle float-right" />
                    </span>
                  </h1>
                  <hr />
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-md-8">
                  <form onSubmit={this.handleSumit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="contact-name">
                            Your Name
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="contact_name"
                            onChange={this.handleInput}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="contact-name">
                            NGO Name
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="ngo_name"
                            onChange={this.handleInput}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="contact-name">
                            Phone Number
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="phone_number"
                            onChange={this.handleInput}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="contact-name">
                            E-mail
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            onChange={this.handleInput}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="description">
                            Tell us what do you do
                            <span className="text-danger">*</span>
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            name="description"
                            onChange={this.handleInput}
                            required
                          />
                        </div>

                        <button
                          className="btn btn-outline-light float-right"
                          type="submit"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <MessageModal
          title={this.state.title}
          message={this.state.message}
          isOpen={this.state.modal}
          toggle={this.modalToggle}
        />
      </div>
    );
  }
}

export default SubmitModal;



// WEBPACK FOOTER //
// ./src/containers/HomePage/submit-modal.js